module.exports = __webpack_public_path__ + "static/media/empf development.d3428d65.gif";